// import { CartMessage } from "../../cart/views/cart-message";
var CustomizerFooter = Backbone.View.extend({
    el: '#customizer-footer-app',
    events: {
        'click .request-a-quote': 'requestQuoteClick',
        'click .share-btn': 'shareClick',
        'click .download-image': 'downloadClick',
        'change .qty': 'changeQty',
        'click .order-samples': 'samplesClick'
    },
    initialize: function( options ){
        this.options = options;
        this.existingProductFlag = typeof options.existing !== 'undefined' ? options.existing : false;
        _.bindAll( this, 'render', 'changeQty', 'requestQuoteClick', 'shareClick', 'downloadClick', 'samplesClick', 'addSampleToCart' );
        this.listenTo( this.model, 'change:cart_index', this.render() );
    },
    render: function(){
        // not much here currently.
        this.$('.qty').val( this.model.get('quantity') );
        if ( this.existingProductFlag ) {
            this.$( 'a.request-a-quote' ).text( 'Update Request' );
        } else {
            this.$( 'a.request-a-quote' ).text( 'Request a Quote' );
        }
    },
    changeQty: function( e ){
        var x = e.target
        if ( /^\d*$/.test( x.value ) ) {
            // only update if it is a number
            this.model.set({'quantity' : x.value });
        } else{
            x.value = this.model.get('quantity');
        }
    },
    requestQuoteClick: function( e ){
        e.preventDefault();
        // alert( 'will add product ' + this.model.get( 'name' ) + 'with SKU' + this.model.get( 'sku' ) + ' to the cart object request a quote' );
        // validate the the product is complete

        var labels = this.model.get( 'settings_labels' );
        var configuration = this.model.get( 'settings' );
        for ( var i in configuration ) {
            var setting = labels[i];
            if (  _.isEmpty(  configuration[i] ) ) {
            
                alert( 'Please select a ' + setting.toUpperCase() + ' option' );
                return false;
            }
        }

        // var existingProductFlag = this.existingProductFlag;
        // if the model is an existing product update, 
        if ( this.existingProductFlag ) {
            window.cart.updateCartProduct( this.model.get( 'cart_id' ), this.model.toJSON() );
        } else {
            window.cart.addProductToCart( this.model.toJSON() );
        }
        // else add it
    },
    shareClick: function( e ){
        e.preventDefault();
        var x = this.model.toJSON();
        var shareURL = x.link + '#customization-section';
        if ( x.settings ) {
            _.each( x.settings, function( val, key ) {
                shareURL += '/' + key + ':' + val.replace(/ /g, '-');
            } );
        }
        if ( x.sku ) {
            shareURL += '/sku:'+x.sku;
        }
        if ( x.quantity ) {
            shareURL += '/quantity:'+parseInt( x.quantity);
        }

        
        shareURL += '/';
        
        var newShareLink = 'mailto:?subject=' + encodeURIComponent( 'Check out the ' + x.name + ' from Grand Rapids Chair Company' ) +'&body=' + shareURL;
		
        window.open( newShareLink );
    },
    downloadClick: function( e ){
        e.preventDefault();
        $( '.download-button.button-icon' ).trigger('click');
    },
    samplesClick: function( e ){
        e.preventDefault();
        var settings = this.model.get( 'settings' );
        if ( ! _.isEmpty( settings ) ) {
            _.each( settings, this.addSampleToCart );
            window.cart.updateCart();
            window.cart.showSideCart();
        }
    },
    addSampleToCart: function( item, key ){
        // console.log( item, key );
        // let labels = this.model.get( 'settings_labels' );
        var keyParts = key.split('_');
        var code = keyParts[0];
        let swatchGroups = _.filter(this.options.product_data.swatch_types, function( group ){ return group.finish_type == code; });
        if ( code == 'fabric' ) {
            // console.log( 'Skipping upholstery fabric', item );
            return;
        }
        if ( ! _.isEmpty( swatchGroups ) ){
            for ( var i = 0; i < swatchGroups.length; i++  ) {
                var group = swatchGroups[i];
                // console.log( group );
                var swatch = _.find( group.swatches, function( swatch ){ return  swatch['code'] == item; } );
                if ( swatch ) {
                    break;
                }
            }
            
            
            if ( ! swatch ) {
                console.warn( 'Swatch not found', item, key );
            } else {
                swatch.finish_type = code;
                swatch.group_label = group.label;
                var response = window.cart.addSample(swatch);
                if ( ! response.success ) {
                    console.warn( response.message );
                    // var cartMessage = new CartMessage({'message' : response.message});
                } 
            }
            
            
        } else {
            console.warn( 'Swatches not set' );
        }
        // alert( response.message );
    }
});

export { CustomizerFooter };